import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const NotFoundComponent = { template: '<div>404</div>' }

  const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import(/* webpackChunkName: "signup" */ '../views/SignUp.vue')
  },
  {
    path: '/signup_success',
    name: 'SignUpSuccess',
    component: () => import(/* webpackChunkName: "signup" */ '../views/SignUpSuccess.vue')
  },
  {
    path: '/emailVerification',
    name: 'EmailVerification',
    component: () => import(/* webpackChunkName: "EmailVerification" */ '../views/EmailVerification.vue')
  },
  {
    path: '/recoverPassword',
    name: 'RecoverPassword',
    component: () => import(/* webpackChunkName: "login" */ '../views/RecoverPassword.vue')
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "login" */ '../views/ResetPassword.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "login" */ '../views/Profile.vue')
  },
  {
    path: '/device/:id?',
    name: 'DeviceInfo',
    component: () => import(/* webpackChunkName: "deviceInfo" */ '../views/DeviceInfo.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/device/:id/configuration',
    name: 'DeviceConfig',
    component: () => import(/* webpackChunkName: "alarmConfig" */ '../views/DeviceConfig.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/device/:id/history',
    name: 'DeviceHistory',
    component: () => import(/* webpackChunkName: "alarmConfig" */ '../views/DeviceHistory.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/device/:id/alarm/history',
    name: 'AlarmHistory',
    component: () => import(/* webpackChunkName: "alarmConfig" */ '../views/AlarmHistory.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },
  {
    path: '/empty',
    name: 'EmptyDevice',
    component: () => import(/* webpackChunkName: "deviceInfo" */ '../views/EmptyDevice.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
    meta: {requiresAuth: true}
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  if(to.matched.some(record => record.meta.requiresAuth)){
    if(store.state.auth.accessToken){
      next()
    }else{
      next({path:'/'})
    }
  }else{
    next()
  }

})

export default router
